import ContentfulTextEssay from 'models/data/contentful/ContentfulTextEssay'
import ContentfulToApiImage from 'models/data/mappings/ContentfulToApiImage'

class ContentfulToApiTextEssay {

    static apiImages = contentfulTextEssay => {
        const contentfulImages = ContentfulTextEssay.images(contentfulTextEssay)
        const apiImages = contentfulImages.map(contentfulImage => ContentfulToApiImage.map(contentfulImage));
        return apiImages
    }

    static map = (contentfulTextEssay) => ({
        id: ContentfulTextEssay.id(contentfulTextEssay),
        title: ContentfulTextEssay.title(contentfulTextEssay),
        subtitle: ContentfulTextEssay.subtitle(contentfulTextEssay),
        bodyHtml: ContentfulTextEssay.bodyHtml(contentfulTextEssay),
        images: ContentfulToApiTextEssay.apiImages(contentfulTextEssay)
    })
}

export default ContentfulToApiTextEssay;